import React from 'react';
import VelvetRopeForm from './VelvetRopeForm';
import TotemCard from './TotemCard';

const Hero = () => {
  return (
    <section className="relative min-h-screen bg-gradient-to-b from-[#050505] via-[#1a1a1a] to-[#050505] flex items-center justify-center px-4 sm:px-6 lg:px-8 py-12 sm:py-16 lg:py-20">
      <div className="max-w-7xl mx-auto w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Left Column - Headline & Content */}
          <div className="text-center lg:text-left space-y-6">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-bold text-white leading-tight">
              Never Stand Alone at the Barrier Again.
            </h1>
            <p className="text-lg sm:text-xl lg:text-2xl text-gray-300 leading-relaxed max-w-2xl mx-auto lg:mx-0">
              Join the private pilot for London's safest Indie music squads. Verified IDs. Zero creeps. Real connection.
            </p>
            
            {/* App Mockup Placeholder */}
            <div className="mt-8 lg:mt-12 flex justify-center lg:justify-start">
              <div className="relative w-full max-w-sm">
                <TotemCard
                  venueName="Gig Venue"
                  totemLocation="Sound Desk (Left Side)"
                  meetTime="19:30"
                  mapImage={{ uri: 'https://images.unsplash.com/photo-1524661135-423995f22d0b?w=800&q=80' }}
                  hostAvatar={{ uri: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&q=80' }}
                  onPress={() => console.log('Open Full Map Modal')}
                />
                
                {/* Squad Chat Placeholder */}
                <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-2xl p-6 border border-gray-700 shadow-2xl">
                  <div className="space-y-3">
                    <div className="text-white font-semibold mb-3">Squad Chat</div>
                    <div className="space-y-2">
                      <div className="bg-gray-700 rounded-lg p-3">
                        <div className="text-gray-300 text-sm">Hey! See you at the barrier?</div>
                      </div>
                      <div className="bg-[#4ADE80]/20 rounded-lg p-3 border border-[#4ADE80]/30">
                        <div className="text-[#4ADE80] text-sm">On my way! 🎸</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column - Velvet Rope Form */}
          <div className="flex justify-center lg:justify-end">
            <VelvetRopeForm />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
